import Echarts from "echarts";
import moment from "moment";
const color = ['#4c9bf2', '#4AC18E', '#D9534F', '#67A8E4'];
const list = [{
    name: "Occ%",
    key: "grand_occ",
    id: "chartOcc"
}, {
    name: "ADR",
    key: "grand_arr",
    id: "chartAdr"
}, {
    name: "REVPAR",
    key: "grand_revpar",
    id: "chartRevpar"
}, {
    name: "Revenue",
    key: "grand_rev",
    id: "chartRev"
}];

export default ({
    data,
    name,
    dataLast,
    date,
}, isOnResize) => {
    list.forEach(item => {
        const myChart = Echarts.init(document.getElementById(item.id));
        myChart.resize();

        if (isOnResize) {
            return
        }

        const year = moment(date).format('YYYY');
        const listName = [`Budget ${year}`, `Actual + Forecast ${year}`, `Actual ${year - 1}`];
        const series = listName.map((name, index) => {
            return {
                name,
                type: 'bar',
                barWidth: 10,
                data: data.reduce((a, b, i) => {
                    if (i >= 36) return a;
                    if (index == 0 && i % 3 == 0) {
                        a.push((b[item.key] * (item.key == 'grand_occ' ? 100 : 1)).toFixed(2));
                    }
                    if (index == 1 && i % 3 == 1) {
                        a.push((b[item.key] * (item.key == 'grand_occ' ? 100 : 1)).toFixed(2));
                    }
                    if (index == 2 && i % 3 == 1) {
                        a.push(dataLast[i] ? (dataLast[i][item.key] * (item.key == 'grand_occ' ? 100 : 1)).toFixed(2) : 0);
                    }
                    return a
                }, []),
            }
        });

        const option = {
            title: {
                text: item.name,
                textStyle: {
                    align: 'left',
                    color: '#333',
                    fontSize: 20,
                },
                top: '5%',
                left: 'left',
            },
            legend: {
                top: '30',
                data: listName
            },
            color,
            xAxis: {
                splitLine: {
                    lineStyle: {
                        show: true,
                    }
                },
                "axisLabel": {
                    textStyle: {
                        fontSize: 12,
                        color: '#000'
                    },
                },
                data: new Array(12).fill(1).map((x, i) => i + 1),
            },
            yAxis: {
                name: item.name == 'Occ%' ? '%' : '',
                type: 'value'
            },
            tooltip: {
                trigger: 'axis',
            },
            toolbox: {
                id: item.id,
                right: 20,
                feature: {
                    saveAsImage: {
                        type: 'png',//	设置图片格式 png或者'jpeg
                        name,
                        backgroundColor: '#FFF',
                        excludeComponents: ['toolbox'],
                        show: true,
                        title: '保存图片',
                        // icon: ...,
                    }
                }
            },
            series
        };

        myChart.setOption(option);
    });

}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/setOption.js